import CRMPageTemplate from '@components/Common/CRMPageTemplate';
import JobMetadataPage from '@components/Settings/JobMetadataPage';
import PlatformSettingsPanel from '@components/Settings/PlatformSettingsPanel';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { Box } from '@mui/material';
import React from 'react';
import './index.scss';

const Settings: React.FC = () => {
  return (
    // "Settings" since the page also holds the site settings; the path stays /job-metadata so
    // bookmarks and links keep working.
    <CRMPageTemplate icon={<LocalOfferOutlinedIcon />} title="Settings">
      <Box className="st-page">
        <PlatformSettingsPanel />
        <JobMetadataPage />
      </Box>
    </CRMPageTemplate>
  );
};

export default Settings;
